import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import {ButtonContained, ButtonOutlined} from '../components/app-button/button'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import SiteBox from '../components/site-box/'
import AppBarInner from '../components/app-bar/AppBarInner'
import { LogoGa } from '../components/app-icon/Icons'
import CustomizeAll from '../components/сustomize-all/'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 630,
    width: '100%',
    marginTop: 52,
  },
  GaIcon: {
    margin: '0 20px 0 25px',
  },
  finishBtn: {
    display: 'block',
    textDecoration: 'none',
    marginTop: 25,
    position: 'relative',
    left: 0,
    width: 160,
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: '100%',
      left: 14,
      height: 25,
      width: 1,
      backgroundColor: 'rgba(136, 102, 255, 0.2)',
    },
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Настройте \nGoogle Analytics \nдля отображения \nрасширенных \nотчетов',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class Confirm extends Component {
  state = {
    activeStep: 2,
    nextUrl: window.state.nextUrl,
    site: window.state.site,
    webProperty: window.state.google_analytics_settings.webProperty,
    view: window.state.google_analytics_settings.view,
    isCard: window.state.cardTest,
  }

  render() {
    const { classes } = this.props
    const { site, webProperty, view, nextUrl, isCard } = this.state
    const steps = isCard ? getSteps() : getSteps().slice(0, -1)

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />

          <div style={{width: 200, position: 'relative'}}>
            <AppStepper activeStep={this.state.activeStep} steps={steps} />
            <a
              href="/wizard/ga/dataset"
              className={classes.finishBtn}
            >
              <ButtonContained full={true} text="Назад"/>
            </a>
          </div>

          <div className={classes.wizardContent}>
            <SiteBox
              url={site.url}
              resource={site.name}
              gutterBottom={8}
              prevUrl={'/wizard/site'}
            />

            <SiteBox
              icon={<LogoGa className={classes.GaIcon} />}
              url={`${webProperty.name} (${webProperty.id})`}
              resource={view.name}
              gutterBottom={24}
              prevUrl={'/wizard/ga/settings'}
            />

            <Typography variant="body1" paragraph style={{ marginTop: 24 }}>
              Проверьте правильность введенных выше данных.
            </Typography>

            <a href={nextUrl} style={{ textDecoration: 'none' }}>
              <ButtonOutlined
                type="button"
                color="secondary"
                text="Продолжить"
              />
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(Confirm)
